import globalStore from "@/store/index";
import { ExtendAxiosRequestConfig } from "./types";
import { getAxiosByShopType } from "./platformAxiosUtil";

export {
    AxiosPlatformType,
    axiosGroupByShopType,
    getAxiosByShopType,
    getAxiosGroupByAxiosPlatformType,
} from "./platformAxiosUtil";

const getAxios = (shopId: number) => {
    const shop = globalStore.shopMapping.get(Number(shopId));

    const shopType = shop?.type;

    return getAxiosByShopType(shopType);
};

// http get
const get = <T>(shopId: any, urlPath: any, params?: any, config: ExtendAxiosRequestConfig = {}): Promise<T> =>
    getAxios(shopId).get(urlPath, { ...config, params });

// http post with json body
const post = <T>(shopId: any, urlPath: any, data?: any, config: ExtendAxiosRequestConfig = {}): Promise<T> =>
    getAxios(shopId).post(urlPath, data, config);

export { get, post };

export default { get, post };
